<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        점검 내역
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Result</a>
          </li>
      </ul>
    </div>
    <!-- <b-card> -->
      <!-- <template slot="header"><i class='fa fa-align-justify'></i>점검 내역</template> -->
      <!-- detail search start -->
      <!--
        상세 점검 내용
        1. 점검 시작 시간 - 적용됨
        2. 점검 종료 시간 - 적용됨
        3. 점검 총 시간
        4. 탐지 여부 - 적용됨
        5. 에러 여부 - 적용됨
        6. 페이지 여부 - ??
       -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> 점검 일시
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> 종료 일시
                <b-button size="sm" variant="info" @click="set_sd('', 'finished_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'finished_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'finished_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'finished_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'finished_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'finished_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.finished_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.finished_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">에러</label><br>
              <c-switch v-if="so.adv" v-model="so.opt.error_count" @change="($event) = so.opt = Object.assign({}, so.opt, { error_count : $event }); refresh()"  color="warning" label variant="pill" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">탐지</label><br>
              <c-switch v-if="so.adv" v-model="so.opt.detect_count" @change="($event) = so.opt = Object.assign({}, so.opt, { detect_count : $event }); refresh()"  color="danger" label variant="pill" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">검색 옵션</label>
            <b-form-group>
              <b-form-radio-group v-model="so.opt.match_type" @change="($event) = so.opt = Object.assign({}, so.opt, { match_type : $event })" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:모두 포함</b-form-radio>
                <b-form-radio value="or">[OR]:하나라도 포함</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button class="btn-add" size="sm" variant="success" @click="refresh"> 검색 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <b-card>
        <b-row>
          <b-col md="5">
            <span class="text-center" v-b-tooltip.hover title="한 페이지에 보여질 개수를 지정합니다">
              표시 수
              <select v-model="so.perPage" @change="refresh">
                <option value="15">기본 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>
            </span>
          </b-col>
          <b-col sm="5">
            <!-- 여기서 고민되는 부분이 점검 결과에서 어떠한 페이지를 검색 할 것인가임 -->
            <!--
              내가 만약 사용자라면 점검하고 싶은 부분
              1. 점검 실패한 부분이나 탐지된 경우
              2. 특정 페이지 범위
            -->
            <b-input-group size="sm" class="pr-3">
              <b-input-group-append>
                <label class="mr-3" for="opt_detect">빠른 검색</label>
              </b-input-group-append>
              <b-input-group-append>
                <label class="mr-3" for="opt_detect">탐지</label>
                <c-switch class="mr-3" :disabled="so.adv"  color="danger" label variant="pill" @change="($event) => { if(loading) { return; } so.sv = $event; so.sk = 'detect_count'; refresh() }" />
              </b-input-group-append>

              <b-input-group-append>
                <label class="mr-3" for="opt_error">에러</label>
                <c-switch class="mr-3" :disabled="so.adv"  color="warning" label variant="pill" @change="($event) => { if(loading) { return; } so.sv = $event; so.sk = 'error_count'; refresh() }"  />
              </b-input-group-append>
            </b-input-group>

          </b-col>
          <b-col sm="1">
            <b-btn block variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
          </b-col>
          <b-col sm="1">
            <b-btn block variant="outline-secondary" @click="search_opt">
              <i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> </i>
            </b-btn>
          </b-col>
        </b-row>
        <hr>
        * <b-badge variant="success">로그인 성공 </b-badge> or <b-badge variant="warning">로그인 실패 </b-badge>
        : 로그인 페이지에서 로그인 후, 401 Unauthorized or 403 Forbidden 이 아닐 경우 성공으로 기록됩니다
        <br>
        * <b-badge variant="primary">티켓 </b-badge>
        : FQDN을 눌러 티켓을 복사할 수 있습니다. 사이트에 문제가 있는 경우 티켓으로 문의하면 빠르게 처리할 수 있습니다.
        <br>
        * <b-badge variant="info">로그인 </b-badge>
        : 로그인 설정의 사용 여부를 표시힙니다
        <br>
        * <b-badge variant="info">JS 이벤트 </b-badge>
        : 링크 클릭시 자바스크립트 클릭 이벤트를 발생합니다(이벤트 발생으로 동작하는 동적 스크립트 수행 가능)
        <br>
        * <b-badge variant="success">정상 </b-badge>
        : 악성코드 배포 및 경유지가 검색되지 않음
        <br>
        * <b-badge variant="danger">탐지 </b-badge>
        : 악성코드 배포 및 경유지가 탐지됨
        <br>
        * <b-badge variant="warning">애러</b-badge>
        : 페이지가 정상적으로 로드되지 않은 경우입니다. 페이지 응답 상태 : <a target="_blank" href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes">400 ~ 500</a>
        <br>
        * <b-badge variant="dark">점검실패</b-badge>
        : 첫번째 페이지에서 확인을 못했거나 시스템에 문제가 있습니다.
        <br>
        * <b-badge variant="primary">점검중</b-badge>
        : 점검중인 실시간 상태를 확인할 수 있습니다 (<small>점검 완료 처리가 되지 않을 경우 표시될 수 있습니다, 이러한 경우 일정 시간 경과시 점검 실패로 분류됩니다</small>)
        <hr>
        <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="fqdn" slot-scope="row">
            <b-img @click="copy(row.item.task_key, site.fqdn)" style="display: inline-block; cursor: pointer;" v-bind="{ width: 15, height: 15 }"  src="ico/copy.ico" alt=""></b-img>
            <b-button variant="link"  style="display: inline-block" :href="'http://'+site.fqdn" target="_blank">
              {{site.fqdn}}
              <b-img src="img/goto_site.png" alt="new Site" v-bind="{ width: 12, height: 12 }"></b-img>
            </b-button>

          </template>
          <template slot="count" slot-scope="row">
            {{ row.item.page_count | number }} ({{ ((row.item.page_count - row.item.ext_count) || 0) | number }} / {{(row.item.ext_count || 0) | number}} / {{(row.item.resource_count || 0)  | number}})
          </template>
          <template slot="created_at" slot-scope="row">
            {{row.item.started_at | datetime}} ~ {{row.item.finished_at | datetime}}
          </template>
          <template slot="status" slot-scope="row">
            <b-badge v-if="row.item.detect_count > 0" variant="danger">탐지 <b-badge variant="light">{{ row.item.detect_count | number }}</b-badge></b-badge>
            <b-badge v-else-if="row.item.finished_at && row.item.page_count < 1" variant="dark">점검 실패</b-badge>
            <b-badge v-else-if="!row.item.finished_at" variant="info">점검중 </b-badge>
            <b-badge v-else variant="success">정상 </b-badge>

            <b-badge v-if="row.item.error_count > 0" variant="warning">에러 <b-badge variant="light">{{ row.item.error_count | number }}</b-badge></b-badge>

            <!-- 400 ~ 500 -->
            <!-- 에러에 대한 추가 설명 필요 -->
          </template>
          <template slot="func" slot-scope="row">
            <b-btn v-if="!row.item.finished_at" @click="sync.task_key = row.item.task_key; timer()"  size="sm" variant="primary">
              <span v-if="sync.status && row.item.task_key == sel_status.task_key" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">&nbsp;</span>
              점검중
            </b-btn>
            <b-btn v-else @click="detail(row.item.id)" size="sm" variant="outline-primary">더 보기</b-btn>
            <b-btn v-if="!row.item.finished_at" @click="scan_stop(row.item.task_key)"  size="sm" variant="warning">중지</b-btn>
          </template>
        </b-table>
        <hr>

        <b-row>
          <b-col md="5">
          </b-col>
          <b-col md="3">
            <b-pagination class="pull-left" size="sm" :total-rows="getRowCount" :per-page="so.perPage" v-model="currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-col md="4">
            <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
            <!-- <b-button v-if="sel_status && sel_status.task_key" size="sm" class="float-right text-white mr-2" variant="info" @click="sync.status = !sync.status"> Auto Refresh ({{sync.timer}}) </b-button> -->
          </b-col>
        </b-row>
        <!-- 사이트 점검 정보 -->
      </b-card>
      <!-- 여기서 상세 내용  보여 줘야 함 -->
      <hr v-if="sel_result && sel_result.id && $route.params.site_id">
      <detail v-if="sel_result && sel_result.id && $route.params.site_id" :result_id="sel_result.id" :item="{ fqdn : site.fqdn }"></detail>
      <status v-if="sel_status && sel_status.task_key" :status="sel_status" :refresh_timer="sync.timer" @stop="sync.status = !sync.status"/>
    <!-- </b-card> -->
    <!-- <hr>
    <router-view @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
